export default [
    "Allopathy",
    "Ayurvedic",
    "Homeopathy",
    "Unani",
    "Siddha",
];